import { isDniFeatureEnabled } from '@/config/featureFlags';
import {
  DEFAULT_COMMUNE,
  DEFAULT_PREFIX_PHONE,
  DEFAULT_REGION
} from '@/constants';
import type { AddressGuest } from '@/modules/customerData/domain/AddressGuest';
import { IdentificationDocumentTypes } from '@/modules/shared/types/IdentificationDocumentType';
import type { AddressGuestFormValues } from '@/sections/customerData/types/AddressGuestFormValues';

const DEFAULT_VALUES = {
  email: '',
  'prefix-phone': DEFAULT_PREFIX_PHONE,
  phone: '',
  firstName: '',
  lastName: '',
  customerRut: '',
  documentType: IdentificationDocumentTypes.RUT,
  documentID: '',
  region: DEFAULT_REGION,
  commune: DEFAULT_COMMUNE,
  'terms-and-cons': false
};

export const getAddressGuestInitialData = (
  address?: AddressGuest
): AddressGuestFormValues => {
  if (!address) return DEFAULT_VALUES;

  const dniEnabled = isDniFeatureEnabled();

  const p = address?.phone ?? '';
  const parts = p.split(' ');
  const phone = parts.length > 1 ? parts.slice(1).join(' ') : p;

  const phoneHasPrefix = p.startsWith('+');

  const phoneWithoutPrefix = phoneHasPrefix
    ? phone.replace(/^\+?\d{1,3}/, '')
    : phone;

  return {
    ...address,
    phone: phoneWithoutPrefix.trim(),
    'prefix-phone': DEFAULT_PREFIX_PHONE,
    documentType:
      !dniEnabled && address.documentType === IdentificationDocumentTypes.DNI
        ? IdentificationDocumentTypes.RUT
        : address.documentType || IdentificationDocumentTypes.RUT,
    documentID:
      !dniEnabled && address.documentType === IdentificationDocumentTypes.DNI
        ? ''
        : address.documentID || '',
    customerRut: address.customerRut || '',
    'terms-and-cons': false
  };
};
